import { render, staticRenderFns } from "./PostForumTextForm.vue?vue&type=template&id=e8ebe77e&"
import script from "./PostForumTextForm.vue?vue&type=script&lang=js&"
export * from "./PostForumTextForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForumTextForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VForm,VIcon,VSelect,VSkeletonLoader})
